import { dashboardApiHost } from "@/constants/urls";
import axios from "axios";
import { ref } from "vue";

export async function getProtectedCampaignGiftList(campaignId, params) {
  const url = `${dashboardApiHost}/orgarea/api/v1/campaign/${campaignId}/campaign-gift/list`;
  const { data } = await axios.get(url, { params });

  return {
    data,
  };
}

export async function getProtectedTeamUserStatList(teamId, params) {
  const url = `${dashboardApiHost}/orgarea/api/v1/chinese-auction/team/${teamId}/stat_list`;
  const { data } = await axios.get(url, { params });

  return {
    data,
  };
}

export function useProtectedCampaignGift() {
  const items = ref([]);
  const loading = ref(false);
  const teamTotal = ref(0);
  const teamPoints = ref(0);
  const subTeamsTotal = ref(0);
  const subTeamsPoints = ref(0);
  const calculatedPointsTotal = ref(0);
  const teamGiftPointsPurchased = ref(0);
  const teamGiftBonusPoints = ref(0);

  async function fetchProtectedCampaignGiftList(campaignId, params, teamId) {
    loading.value = true;

    try {
      const queryParams = teamId ? { ...params, team_id: teamId } : params;
      const { data } = await getProtectedCampaignGiftList(campaignId, queryParams);

      data.sort((a, b) => {
        return b.order - a.order;
      });

      items.value = data;
    } catch (e) {
      console.error(e);
      throw e;
    } finally {
      loading.value = false;
    }
  }

  async function fetchProtectedTeamUserStatList(teamId, params) {
    loading.value = true;

    try {
      const { data } = await getProtectedTeamUserStatList(teamId, params);
      teamTotal.value = data.team_total;
      teamPoints.value = data.team_points;
      subTeamsTotal.value = data.sub_teams_total;
      subTeamsPoints.value = data.sub_teams_points;
      calculatedPointsTotal.value = data.calculated_points_total;
      teamGiftPointsPurchased.value = data.team_gift_points_purchased;
      teamGiftBonusPoints.value = data.team_gift_bonus_points;
    } catch (e) {
      console.error(e);
      throw e;
    } finally {
      loading.value = false;
    }
  }

  return {
    items,
    teamTotal,
    teamPoints,
    subTeamsTotal,
    subTeamsPoints,
    calculatedPointsTotal,
    teamGiftPointsPurchased,
    teamGiftBonusPoints,
    loading,
    fetchProtectedCampaignGiftList,
    fetchProtectedTeamUserStatList,
  };
}
